module.exports = "\r\n<div id=\"ratingOverview\">\r\n\t<img src=\"./assets/images/icons/logo.png\" style=\"margin-top: 5px;\">\r\n</div>\r\n"